import { render } from "./ComboardForm.vue?vue&type=template&id=cea60cdc"
import script from "./ComboardForm.vue?vue&type=script&lang=js"
export * from "./ComboardForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__